import TypeOfAccountRequired from "@/layouts/auth/components/TypeOfAccountRequired";
import UserSettings from "@/layouts/navigation/user-settings";
import Address from "@/pages/user-settings/address";
import ArtistQrSettings from "@/pages/user-settings/artist-qr";
import BankAccount from "@/pages/user-settings/bank-account";
import ClosedMode from "@/pages/user-settings/closed-mode";
import CommunityPreferences from "@/pages/user-settings/communication_preferences/community";
import EmailsPreferences from "@/pages/user-settings/communication_preferences/emails";
import NotificationsPreferences from "@/pages/user-settings/communication_preferences/notifications";
import Cookies from "@/pages/user-settings/cookies";
import EditProfile from "@/pages/user-settings/edit-profile";
import GalleryInformation from "@/pages/user-settings/gallery-information";
import GalleryQrSettings from "@/pages/user-settings/gallery-qr";
import LanguageSettings from "@/pages/user-settings/language";
import LogIn from "@/pages/user-settings/log-in";
import ModeAndTheme from "@/pages/user-settings/mode-theme";
import PaymentMethods from "@/pages/user-settings/payment-methods";
import PriceSettings from "@/pages/user-settings/price";
import Privacy from "@/pages/user-settings/privacy";
import SettingsIndex from "@/pages/user-settings/settings-index";
import Terms from "@/pages/user-settings/terms";

const UserSettingsRoutes = [
  {
    path: "/profile/settings",
    element: <UserSettings/>,
    children: [
      { index: true, element: <SettingsIndex/> },

      {
        element: <TypeOfAccountRequired allowedTypes={["gallery"]}/>,
        children: [
          { path: "/profile/settings/gallery-information", element: <GalleryInformation/> },
          { path: "/profile/settings/payments-profile", element: <BankAccount/> },
          { path: "/profile/settings/closed-mode", element: <ClosedMode/> },
          { path: "/profile/settings/gallery-qr", element: <GalleryQrSettings/> },
          { path: "/profile/settings/price", element: <PriceSettings/> },
        ]
      },

      {
        element: <TypeOfAccountRequired allowedTypes={["artist", "collector"]}/>,
        children: [   
          { path: "/profile/settings/address", element: <Address/> },
          { path: "/profile/settings/payment-methods", element: <PaymentMethods/> },
        ]
      },

      {
        element: <TypeOfAccountRequired allowedTypes={["artist"]}/>,
        children: [
          { path: "/profile/settings/artist-qr", element: <ArtistQrSettings/> },
        ]
      },

      { path: "/profile/settings/edit-profile", element: <EditProfile/> },
      { path: "/profile/settings/login", element: <LogIn/> },
      { path: "/profile/settings/mode-theme", element: <ModeAndTheme/> },
      { path: "/profile/settings/language", element: <LanguageSettings/> },
      { path: "/profile/settings/community", element: <CommunityPreferences/> },
      { path: "/profile/settings/notifications", element: <NotificationsPreferences/> },
      { path: "/profile/settings/emails", element: <EmailsPreferences/> },
      { path: "/profile/settings/privacy", element: <Privacy/> },
      { path: "/profile/settings/terms", element: <Terms/> },
      { path: "/profile/settings/cookies", element: <Cookies/> },
    ]
  }
];

export default UserSettingsRoutes;
